import * as Yup from "yup";

// initial values for the form
export const fleettagDetailsInitialValues = {
  fleet_tag_id: "",
  fleet_tag_name: "",
  last_event_time: "",
  last_status_code: "", // 0,
  in_range: "",
  in_range_device_id: "",
  last_location: "",
  last_address: "",
  last_altitude: 0,
  distance_travelled: 0,
  tag_signal_strength: 0,
  tag_battery_level: 0,
  temprature: 0,
};

// validation schema for the form
export const fleettagDetailsYupValidationSchema = Yup.object().shape({
  fleet_tag_id: Yup.string().required("FleetTag ID is required"),
  fleet_tag_name: Yup.string().required("FleetTag Name is required"),
});
